import React from "react";
import { connect } from "react-redux";
import "../../../Dashboard/dashboard.css";
import { useEffect } from "react";
import {
  generateForecastCashToEarnings,
} from "../../../../store/modules/forecastCashToEarning/actions";
import InputLabel from "@mui/material/InputLabel";
import { rowStyle } from "../../../Dashboard/customStyles";
import BVAInput from "../../../../components/BVAInput/BVAInput";


const ForecastCashToEarnings = ({
  forecastCashToEarnings,
  appState,
  dispatchGenerateForecastCashToEarnings
}) => {
  // Mounted
  useEffect(() => {
    dispatchGenerateForecastCashToEarnings()
  }, [])


  return (
    <>
      <h2 className="sectionHead">Forecasted Cash to Earnings</h2>
      <div className="dashboard-content">
          <div className="data-title-container">
            <div></div>

            <div className="data-title">
              <h6>{appState.companyData.name}</h6>
              <p>Pre-Tax Net Income Conversion Factor</p>
            </div>
          </div>

          <div style={rowStyle.baseRow}>
            <div style={rowStyle.labelRow}>
              <InputLabel>Pre-Tax Free Cash Flow</InputLabel>
            </div>
            <div style={rowStyle.fieldRow}>
              <BVAInput
              disabled
              value={forecastCashToEarnings?.preTaxNetIncomeConversionFactor?.preTaxFreeCashFlow}
              startAdornment
              size="small"
              startAdornmentLabel="$"/>
            </div>
          </div>

          <div style={rowStyle.baseRow}>
            <div style={rowStyle.labelRow}>
              <InputLabel>
                {"Earnings Before Interest & Taxes (EBIT)"}
              </InputLabel>
            </div>
            <div style={rowStyle.fieldRow}>
              <BVAInput
              disabled
              startAdornment
              startAdornmentLabel="$"
              size="small"
              value={forecastCashToEarnings?.preTaxNetIncomeConversionFactor?.ebit}/>
            </div>
          </div>

          <div style={rowStyle.baseRow}>
            <div style={rowStyle.labelRow}>
              <InputLabel style={{ fontWeight: "bold" }}>
                Predicted Factor (%)
              </InputLabel>
            </div>
            <div style={rowStyle.fieldRow}>
              <BVAInput
              disabled
              endAdornment
              endAdornmentLabel="%"
              size="small"
              value={forecastCashToEarnings?.preTaxNetIncomeConversionFactor?.predictedFactor}/>
            </div>
          </div>

          <div className="data-title-container pt-10">
            <div></div>

            <div className="data-title">
              <h6>{appState.companyData.name}</h6>
              <p>Cash to Earnings Factor</p>
            </div>
          </div>

          <div style={rowStyle.baseRow}>
            <div style={rowStyle.labelRow}>
              <InputLabel>
                Pre-Tax Net Cash Flow Capitalization Rate (%)
              </InputLabel>
            </div>
            <div style={rowStyle.fieldRow}>
              <BVAInput
                disabled
                size="small"
                endAdornment
                endAdornmentLabel="%"
                value={forecastCashToEarnings?.cashToEarningsFactor?.preTaxNetCashFlowCapitalizationRate}/>
            </div>
          </div>

          <div style={rowStyle.baseRow}>
            <div style={rowStyle.labelRow}>
              <InputLabel>Predicted Factor %</InputLabel>
            </div>
            <div style={rowStyle.fieldRow}>
              <BVAInput
                disabled
                endAdornment
                endAdornmentLabel="%"
                size="small"
                value={forecastCashToEarnings?.cashToEarningsFactor?.predictedFactor}/>
            </div>
          </div>

          <div style={rowStyle.baseRow}>
            <div style={rowStyle.labelRow}>
              <InputLabel>Pre-Tax Net Income Capitalization Rate</InputLabel>
            </div>
            <div style={rowStyle.fieldRow}>
              <BVAInput
                disabled
                endAdornment
                endAdornmentLabel="%"
                size="small"
                value={forecastCashToEarnings?.cashToEarningsFactor?.preTaxNetIncomeCapitalizationRate}/>
            </div>
          </div>

          <div style={rowStyle.baseRow}>
            <div style={rowStyle.labelRow}>
              <InputLabel>
                Less: Pre-Tax Net Cash Flow Capitalization Rate %
              </InputLabel>
            </div>
            <div style={rowStyle.fieldRow}>
              <BVAInput
                disabled
                endAdornment
                endAdornmentLabel="%"
                size="small"
                value={forecastCashToEarnings?.cashToEarningsFactor?.preTaxNetCashFlowCapitalizationRate}/>
            </div>
          </div>

          <div style={rowStyle.baseRow}>
            <div style={rowStyle.labelRow}>
              <InputLabel style={{ fontWeight: "bold" }}>
                Cash to Earnings Factor (%)
              </InputLabel>
            </div>
            <div style={rowStyle.fieldRow}>
              <BVAInput
                disabled
                endAdornment
                endAdornmentLabel="%"
                size="small"
                value={forecastCashToEarnings?.cashToEarningsFactor?.cashToEarningsFactor}/>
            </div>
          </div>

          <div style={rowStyle.baseRow}>
            <div style={rowStyle.labelRow}>
              <InputLabel style={{ fontWeight: "bold" }}>
                Pre-Tax Income Multiple
              </InputLabel>
            </div>
            <div style={rowStyle.fieldRow}>
              <BVAInput
                disabled
                endAdornment
                endAdornmentLabel="x"
                size="small"
                value={forecastCashToEarnings?.cashToEarningsFactor?.preTaxIncomeMultiple}/>
            </div>
          </div>
        </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    forecastCashToEarnings: state.forecastCashToEarning.forecastCashToEarnings,
    taxes: state.taxes,
    appState: state.appState,
  };
};

const mapDispatchToProps = (dispatch) => ({
  dispatchGenerateForecastCashToEarnings() {
    dispatch(generateForecastCashToEarnings())
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(ForecastCashToEarnings);
